import { CanDeactivateFn, RouterStateSnapshot } from '@angular/router';

import {
    FormUnsavedChangesWarningBase,
    SaveGuardCallback,
    unsavedChangesHandler,
} from '@r1-compass-library/guards/hasUnsavedChanges.guard';
import { Observable, of } from 'rxjs';

export interface AdminDivisionSaveGuard extends FormUnsavedChangesWarningBase<'formUnsavedChangesWarningMisc'> {
    canDeactivate$: Observable<{
        dirtied: boolean;
        valid: boolean;
    }>;
    onSave: () => void;
}

/**
 * @description Some pages have obstacles to saving that were not worth addressing compared to the need for a warning
 * @description Admin Settings > `AdminDivisionsComponent` save method was annoying, and that page doesn't change often
 *
 * Basically the same as `hasUnsavedChanges.guard.ts` from the library, but enough differences that were hard to abstract
 */
export const hasUnsavedChangesAdminDivision: CanDeactivateFn<AdminDivisionSaveGuard> = (
    _component: AdminDivisionSaveGuard,
    _currentRoute,
    _routerStateSnapshot,
    nextState: RouterStateSnapshot
): Observable<boolean> => {
    const responseCallback = (response: SaveGuardCallback) => {
        return response?.type === 'confirm' || response?.type === 'confirmWithoutSave' ? of(true) : of(false);
    };

    return unsavedChangesHandler(nextState, responseCallback, false);
};
